import { render, staticRenderFns } from "./Myapprovals.vue?vue&type=template&id=4ccdcd22&scoped=true&"
import script from "./Myapprovals.vue?vue&type=script&lang=js&"
export * from "./Myapprovals.vue?vue&type=script&lang=js&"
import style0 from "./Myapprovals.vue?vue&type=style&index=0&id=4ccdcd22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdcd22",
  null
  
)

export default component.exports